import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import {
  type INetworkErrorPage,
  NetworkErrorBodySwitch,
} from '@framework/ui/components/alert/NetworkErrorBodySwitch.tsx';
import { useTranslation } from 'react-i18next';
import { AlertPageLayout } from '../components/AlertPageLayout.tsx';
import { getDefaultErrorTextFromStatus } from './getDefaultErrorMessageFromStatus.ts';

export function NetworkAlertPage(props: INetworkErrorPage) {
  const { message, error, description, noLayout } = props;

  const { t } = useTranslation();
  const defaultText = getDefaultErrorTextFromStatus(t, error?.response?.status);

  const errorProps = {
    message: message ?? defaultText.message,
    title: defaultText.title,
    description: description ?? getNetworkErrorMessage(error ?? ''),
    status: error?.response?.status,
  };

  return (
    <AlertPageLayout noLayout={noLayout}>
      <NetworkErrorBodySwitch {...errorProps} />
    </AlertPageLayout>
  );
}
